import { guestUser } from '~/api/user';
import useRootData from '~/hooks/useRootData';
import type { Users } from '~/types';

export const useUser = (): Users.User => {
  const rootData = useRootData();

  return rootData?.user || guestUser;
  // const user = isServer()
  //   ? (rootData?.user ?? null)
  //   : (window.rootData?.user ?? rootData?.user ?? null);
  // return user;
};
